// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Apqqx","location":"Header_location__38Yo5"};